export default __webpack_public_path__ + "static/media/add-circle.ac3a9aa2.svg";